import { render, staticRenderFns } from "./table-datalog.editor.vue?vue&type=template&id=53360573&scoped=true&"
import script from "./table-datalog.editor.vue?vue&type=script&lang=ts&"
export * from "./table-datalog.editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53360573",
  null
  
)

export default component.exports